const { errorTagsLocales } = require('./errorTags');
const { kycDocumentsTypesLocales } = require('./kycDocs');
const { parseTags } = require('./tags');

const FALLBACK_LOCALE = 'en';

// Ex: for tags, output is: "ID_RECTO:CROPPED,EXPIRED PROOF_OF_ADDRESS_HOST:BLURRY"
//
// - Recto de la Carte d'identité: rogné, expiré ou de plus de 3 mois
// - Justificatif de domicile (hébergeur): flou
const getFormatedErrorMessageFromTags = (lang = FALLBACK_LOCALE) => (
  tagsString,
) => {
  const parsedTags = parseTags(tagsString);

  const getTypeLocales = (documentType) => {
    if (
      kycDocumentsTypesLocales[lang] &&
      kycDocumentsTypesLocales[lang][documentType]
    ) {
      return kycDocumentsTypesLocales[lang][documentType];
    }
    return kycDocumentsTypesLocales[FALLBACK_LOCALE][documentType];
  };
  const getTagLocales = (tag) => {
    if (errorTagsLocales[lang] && errorTagsLocales[lang][tag]) {
      return errorTagsLocales[lang][tag].description;
    }
    if (errorTagsLocales[FALLBACK_LOCALE][tag]) {
      return errorTagsLocales[FALLBACK_LOCALE][tag].description;
    }
    return '';
  };

  return parsedTags.reduce((acc, { documentType, tags }, index) => {
    const tagsLocale = tags.reduce((accTag, tag) => {
      if (!getTagLocales(tag)) {
        return accTag;
      }

      return `${accTag}${accTag === '' ? '' : ', '}${getTagLocales(tag)}`;
    }, '');

    if (!getTypeLocales(documentType) || tagsLocale === '') {
      return acc;
    }

    return `${acc}${parsedTags.length > 1 ? '- ' : ''}${getTypeLocales(
      documentType,
    )}${lang === 'fr' ? ' ' : ''}: ${tagsLocale}${
      index === parsedTags.length - 1 ? '' : '\n'
    }`;
  }, '');
};

module.exports = {
  getFormatedErrorMessageFromTags,
};
